import React from 'react';
import { DragDropContext, Droppable, Draggable, } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';
import { selectProcedures } from '@debbie/cortex/dist/procedures/selectors.js';
import X from './Icons/X.js';
import Select from './Select.js';
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    borderRadius: '3px',
    // change background colour if dragging
    background: '#fff',
    // styles we need to apply on draggables
    ...draggableStyle,
});
const getListStyle = (isDraggingOver) => ({
    padding: '5px 0px',
});
const AutoCallActions = (props) => {
    const proceduresList = useSelector((s) => selectProcedures(s));
    const lang = useSelector((s) => s.lang);
    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const items = reorder(props.actions, result.source.index, result.destination.index);
        props.onChange(cleanup(items));
    };
    return (React.createElement("div", null, 
    // @ts-ignore
    React.createElement(DragDropContext, { onDragEnd: onDragEnd },
        React.createElement(Droppable, { droppableId: "droppable" }, (provided, snapshot) => (React.createElement("div", { ...provided.droppableProps, ref: provided.innerRef, style: getListStyle(snapshot.isDraggingOver) },
            props.actions.map((item, index) => (React.createElement(Draggable, { key: item.id, draggableId: item.id, index: index }, (provided, snapshot) => (React.createElement("div", { ref: provided.innerRef, ...provided.draggableProps, ...provided.dragHandleProps, 
                //@ts-ignore
                style: getItemStyle(snapshot.isDragging, 
                //@ts-ignore
                provided.draggableProps.style) },
                React.createElement("p", null,
                    React.createElement("b", null,
                        index + 1,
                        "#"),
                    React.createElement(X, { style: {
                            cursor: 'pointer',
                            float: 'right',
                        }, onClick: () => {
                            props.onChange(cleanup(props.actions.filter((a, _i) => _i !== index)));
                        } })),
                React.createElement(Select, { value: item.procedureId || '', onChange: (e) => {
                        props.onChange(cleanup(props.actions.map((a, _i) => {
                            if (_i == index) {
                                return {
                                    ...a,
                                    procedureId: e.target.value || null,
                                };
                            }
                            return a;
                        })));
                    } }, proceduresList &&
                    proceduresList.map((procedure) => (React.createElement("option", { key: procedure.procedureId, value: procedure.procedureId },
                        lang.standardProcedureTitles[procedure.procedureId] || procedure.title,
                        ' ',
                        "-",
                        ' ',
                        lang.standardProcedureDescriptions[procedure.procedureId] || procedure.description))))))))),
            provided.placeholder))))));
};
export default AutoCallActions;
const cleanup = (actions) => {
    return actions
        .filter((a) => a.procedureId)
        .map((a) => a);
};
//# sourceMappingURL=AutoCallActions.js.map